// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O65e7","col":"styles_col__2_sib"};